export default "__VITE_ASSET__CueeMFej__"